module.exports = __webpack_public_path__ + "static/img/chair_ai_max.466350ea.png";